import { render, staticRenderFns } from "./Debtors.vue?vue&type=template&id=607c50bf&scoped=true"
import script from "./Debtors.vue?vue&type=script&lang=js"
export * from "./Debtors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607c50bf",
  null
  
)

export default component.exports